
export default {
  name: 'ViewCategory',
  props: {
    page: {
      type: Object,
      required: true,
    },
    categoryParams: {
      type: Object,
      required: true,
    },
  },
}
